import type { CssType } from '@compiled/react';
import { N0, N20 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { BASE_HEADER_HEIGHT, zIndex } from '../../common/constants';
import { secondaryBorder } from '../../common/styled';

export const headerContainerStyles: CssType<void> = {
	position: 'sticky',
	boxSizing: 'border-box',
	width: '100%',
	top: 0,
	background: token('elevation.surface', N0),
	borderRadius: `${token('border.radius', '3px')} 0 0 0`,
	zIndex: zIndex.ROW_HEADER,
};

export const headerRowStyles: CssType<void> = {
	position: 'relative',
	display: 'flex',
};

export const dateHeaderRowStyles: CssType<void> = {
	height: `${BASE_HEADER_HEIGHT}px`,
	backgroundColor: token('color.background.neutral', N20),
};

export const dateHeaderCellsContainerStyles: CssType<void> = {
	position: 'relative',
	boxSizing: 'border-box',
	height: `${BASE_HEADER_HEIGHT}px`,
	borderTop: secondaryBorder,
	borderBottom: secondaryBorder,
	zIndex: zIndex.HEADER,
};

export const subHeaderCellsContainerStyles: CssType<void> = {
	position: 'relative',
	boxSizing: 'border-box',
	display: 'flex',
	alignItems: 'center',
	padding: 0,
	borderBottom: secondaryBorder,
	zIndex: zIndex.HEADER,
};
